export type StringRecord<T> = Record<string, T>;

type ValueGuard<T> = (value: unknown) => value is T;

export const isString = (value: unknown): value is string => typeof value === "string";

export const isFiniteNumber = (value: unknown): value is number =>
    typeof value === "number" && Number.isFinite(value);

export function isStringRecord<T>(value: unknown, isValue: ValueGuard<T>): value is StringRecord<T> {
    return (
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value) &&
        Object.values(value).every(isValue)
    );
}

export function parseStringRecord<T>(raw: string | null, isValue: ValueGuard<T>): StringRecord<T> {
    if (!raw) return {};

    const value: unknown = JSON.parse(raw);
    return isStringRecord(value, isValue) ? value : {};
}
